export type ReceptionCategory = 'food' | 'drinks' | 'sweets'

export type ReceptionOffering = {
  id: string
  category: ReceptionCategory
  name: string
  description: string
  supplierIds: string[]
  selfProvided: boolean
}

export type ReceptionPlan = {
  offerings: ReceptionOffering[]
  vendorMeals: number | null
  notes: string
  documents: { id: string; name: string; sizeBytes: number }[]
}

export function emptyReception(): ReceptionPlan {
  return { offerings: [], vendorMeals: null, notes: '', documents: [] }
}

export function planningReception(): ReceptionPlan {
  return {
    offerings: [
      {
        id: 'food-menu',
        category: 'food',
        name: 'Svatební menu',
        description: 'Servírované menu, dětská a bezmasá varianta.',
        supplierIds: ['sup-gastro'],
        selfProvided: false,
      },
      {
        id: 'food-buffet',
        category: 'food',
        name: 'Večerní raut',
        description: 'Mini burgery, zeleninové wrapy a sýrová prkénka.',
        supplierIds: ['sup-gastro'],
        selfProvided: false,
      },
      {
        id: 'drinks-venue',
        category: 'drinks',
        name: 'Nápoje od místa',
        description: 'Voda, limonády, čepované pivo, káva a čaj.',
        supplierIds: ['sup-loucen'],
        selfProvided: false,
      },
      {
        id: 'drinks-own',
        category: 'drinks',
        name: 'Vlastní víno a prosecco',
        description: 'Bílé a růžové víno, prosecco na přípitek.',
        supplierIds: [],
        selfProvided: true,
      },
      {
        id: 'sweets-cake',
        category: 'sweets',
        name: 'Malinový dort s vanilkou',
        description: 'Dvoupatrový dort a drobné dezerty na sladký bar.',
        supplierIds: ['sup-dorty'],
        selfProvided: false,
      },
    ],
    vendorMeals: null,
    notes:
      'Finální počty nahlásit cateringu dva týdny před svatbou. Na degustaci vyzkoušet i bezmasou variantu.',
    documents: [{ id: 'reception-offer', name: 'Nabídka cateringu.pdf', sizeBytes: 240000 }],
  }
}
